import React from "react";
import checkmarkImg from "../../images/purple-check-mark.png";
import './testimonial.css';

function Testimonial({ section, isMobile }) {
  return (
    <div className="testimonial-wrapper">
      <p className="testimonial-sub-title ">{section.title(isMobile)}</p>
      <ul className="testimonial-description">
        {section.items.map((item, ind) => (
          <li className="flex mb-5 text-start" key={ind}>
            <img 
              src={checkmarkImg}
              className="testimonial-checkmark"
              style={{ width: 20, height: 20 }}
              alt="check-mark"
            />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Testimonial;
